.progress {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.header {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  justify-content: space-between;
}

.label {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.hiddenLabel {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.value {
  color: var(--color-text);
  font-size: var(--text-sm);
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.track {
  position: relative;
  overflow: hidden;
  block-size: var(--space-1);
  border-radius: var(--radius-full);
  background: var(--color-surface-active);
}

.indicator {
  block-size: 100%;
  border-radius: var(--radius-full);
  background: var(--color-info);
}

.progress[data-complete] .indicator {
  background: var(--color-success);
}

/* Indeterminate: a sliding segment; static under reduced motion. */
.progress[data-indeterminate] .indicator {
  position: absolute;
  inline-size: 30%;
  animation: slide calc(var(--duration-pulse) * 0.75) linear infinite;
}

@keyframes slide {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(340%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .progress[data-indeterminate] .indicator {
    animation: none;
  }
}
